import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class LandscapeOverlay extends BaseComp.default {
	componentDidMount() {
		disableBodyScroll();
	}

	componentWillUnmount() {
		enableBodyScroll();
	}
}
